import { Extension, Editor } from '@tiptap/core';
import Suggestion, { SuggestionOptions } from '@tiptap/suggestion';
import { Plugin, PluginKey } from 'prosemirror-state';
import { CommandItem } from '../components/SlashCommandsList';

// Create a proper plugin key for the suggestion plugin
export const slashCommandsPluginKey = new PluginKey('slashCommands');

type CommandProps = {
  editor: Editor;
  range: { from: number; to: number };
  props: CommandItem;
};

// Define proper types for the suggestion options
interface SlashCommandsOptions {
  suggestion: Partial<SuggestionOptions>;
}

// Create the SlashCommands extension
export const SlashCommands = Extension.create<SlashCommandsOptions>({
  name: 'slashCommands',

  addOptions() {
    return {
      suggestion: {
        char: '/',
        pluginKey: slashCommandsPluginKey,
        command: ({ editor, range, props }: CommandProps) => {
          // First delete the slash character and the trigger text
          // This needs to happen before any command execution
          editor.chain().focus().deleteRange(range).run();

          // Execute the command from the CommandItem
          // Each command should handle its own logic
          if (props?.command) {
            props.command({ editor });
          }
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        ...this.options.suggestion,
        editor: this.editor,
      }) as unknown as Plugin,
    ];
  },
});
